import { config } from '../../config'

export const FEATURE_FLAGS = {
  feedbackFormEnable: config.common.environment != 'production' ? true : false,
}
